/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext, useCallback, useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// import { useValidation } from 'gw-portals-validation-react';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { MLLocalDateUtil,MLProductCodeUtil } from 'ml-portals-util-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import '@xengage/gw-platform-translations';
import _ from 'lodash';

import metadata from './MLPAEditDriverComponent.metadata.json5';
import agentmetadata from './MLPAAgentEditDriverComponent.metadata.json5';
import styles from './MLPAEditDriverComponent.module.scss';
import messages from './MLPAEditDriverComponent.messages';
import SpousePopoverComponent from '../SpousePopoverComponent/SpousePopoverComponent';
import MLModifierComponent from '../MLModifierComponent/MLModifierComponent';
import MLNameDetailsComponent from '../MLNameDetailsComponent/MLNameDetailsComponent';
import { useTranslator } from '@jutro/locale';
import { TooltipContent } from '@jutro/components';
import Address from "../Models/Address";

// ML: MLPAEditDrivers.js, MLPAEditDriverDirectiveCtrl.js, ml-pa-edit-driver.html / ml-pa-agent-edit-driver.html

function MLPAEditDriverComponent(props) {
    const {
        submissionVM,
        driverVM,
        driverList,
        showValidtionErrors,
        handleDriverModelChange,
        isFieldDefaultedByHvq,
        updateModifiers,
        onValidate,
        isPolicyChange,
        updateWizardData
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const goodStudentTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('GoodStudent_ML');
    const [occupationtypelist, updateOccupationtypelist] = useState();
    const schoolAddressVM = _.get(driverVM, 'schoolAddress_Ext');

    const minDriverAgeGoodStudent = 14;
    const maxDriverAgeGoodStudent = 24;

    // const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);
    const translator = useTranslator();

    useEffect(() => {
        const initOccupationTypeList = () => {
            let categories;
            if(isModernProduct){
                categories = driverVM.occupation_Ext.aspects.availableValues.filter((value) => {
                    return (value.code.endsWith('_np') || value.code === 'military' || value.code === 'other');
                });
            }
            else{
                categories = driverVM.occupation_Ext.aspects.availableValues.filter((value) => {
                    return (!value.code.endsWith('_np'));
                });
            }

            const categoryCodes = categories.map((category) => ({
                code: category.code,
                name: translator({
                    id: category.name,
                    defaultMessage: category.name
                })
            }));

            updateOccupationtypelist(categoryCodes);
        }

        initOccupationTypeList();

        if (schoolAddressVM?.value && schoolAddressVM?.value?.postalCode) {
            _.set(driverVM, 'schoolAddress_Ext.value', schoolAddressVM.value);
        }

    }, []);

    const {
        checkUniqueSelf,
        checkUniqueSpouse,
        getFilteredGender
    } = MLDriverVehicleUtil();

    const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
    const isAgentEndorsement = appConfig.agentendorsement === 'true';
    const isQnB = appConfig.portalCode === 'QB';
    const isMarriedStatus = useCallback(() => {
        return !!driverVM.maritalStatus_ML.value && driverVM.maritalStatus_ML.value.code === 'M';
    }, [driverVM]);

    const goodStudentType = useCallback(() => {
        if (!_.isUndefined(driverVM.goodStudentType_ML) && !_.isUndefined(driverVM.goodStudentType_ML.value))
            return driverVM.goodStudentType_ML.value.code;
    }, [driverVM]);

    const isModelBridgedAndDefaultedByHVQ = useCallback((model) => {
        // eslint-disable-next-line no-underscore-dangle
        return !!driverVM.bridgedFromHVQ_ML?.value && isFieldDefaultedByHvq && isFieldDefaultedByHvq(model._accessorCode);
    }, [driverVM.bridgedFromHVQ_ML, isFieldDefaultedByHvq]);

    const isModifierBridgedAndDefaultedByHVQ = useCallback((model) => {
        return !!driverVM.bridgedFromHVQ_ML?.value && !!isFieldDefaultedByHvq && !!isFieldDefaultedByHvq(model);
    }, [driverVM.bridgedFromHVQ_ML, isFieldDefaultedByHvq]);
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';

    useEffect(() => {
        if (!isQnB) return;

        const updatedDriverList = driverList.map(driver => {
            const modifiers = _.get(driver, 'driverModifiers_ML.modifiers', []);

            const updatedModifiers = modifiers.map(mod => {
                if (mod.codeIdentifier_ML === 'PADriverSignalProgramPhoneNumber_Ext') {
                    return {
                        ...mod,
                        chosenTermValue: null,
                        isInputValueRequired_ML: false, 
                    };
                } else if(mod.codeIdentifier_ML === 'PADriverSignalProgram_Ext') {
                    if(driverVM.maritalStatus_ML.value === undefined && driverVM.occupation_Ext.value === undefined){
                        const signalIdx = _.get(driver,'driverModifiers_ML.modifiers')?.findIndex(m => m?.codeIdentifier_ML === 'PADriverSignalProgram_Ext')

                        if(signalIdx !== -1) {
                            _.set(driver, `driverModifiers_ML.modifiers[${signalIdx}].chosenTermValue`, true);
                            _.set(driver, `driverModifiers_ML.modifiers[${signalIdx}].updated`, true);
                        }
                    }
                }
                return mod;
            });

            return {
                ...driver,
                driverModifiers_ML: {
                    ...driver.driverModifiers_ML,
                    modifiers: updatedModifiers
                },
            };
        });

        updateWizardData({
            ...submissionVM,
            lobData: {
                ...submissionVM.lobData,
                personalAuto: {
                    ...submissionVM.lobData.personalAuto,
                    coverables: {
                        ...submissionVM.lobData.personalAuto.coverables,
                        drivers: {
                            value: updatedDriverList,
                        },
                    },
                },
            },
        });
    }, [isQnB]);

    //
    // Good Student
    //

    const getDriverAge = (driverDateOfBirth) => {
        const dob = MLLocalDateUtil.localDate2Date(driverDateOfBirth);
        const today = new Date();
        return MLLocalDateUtil.differenceInYears(today, dob);
    };

    const isQuoted = (quoteNumber) => {
        if (!quoteNumber) return false;
        const list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY) || '[]');
        return list.includes(quoteNumber);
    };

    const isGoodStudentVisible = useCallback(() => {
          if (!driverVM?.dateOfBirth?.value) {
            return false;
        }
        const driverAge = getDriverAge(driverVM.dateOfBirth.value);
    
        if (isModernProduct) {
            return    driverAge >= minDriverAgeGoodStudent
            && driverAge <= maxDriverAgeGoodStudent &&
            driverVM?.maritalStatus_ML?.value?.code==='S'
        }
        else{
        return !!driverVM.occupation_Ext.value
            && driverVM.occupation_Ext.value.code === 'student'
            && driverAge >= minDriverAgeGoodStudent
            && driverAge <= maxDriverAgeGoodStudent;
         }
    }, [driverVM.dateOfBirth.value, driverVM.occupation_Ext.value]);

    const isGoodStudentOptionVisible = useCallback(() => {
        return isGoodStudentVisible()
            && !!driverVM.isGoodStudent_ML.value;
    }, [driverVM.isGoodStudent_ML.value, isGoodStudentVisible]);

    const clearGoodStudentIfNotApplicable = useCallback(() => {
        if (!isGoodStudentVisible()) {
            driverVM.isGoodStudent_ML.value = undefined;
        }
    }, [driverVM.isGoodStudent_ML, isGoodStudentVisible]);
    clearGoodStudentIfNotApplicable();

    // initial default good student type
    const defaultGoodStudentType = useCallback(() => {
        if (driverVM.isGoodStudent_ML.value && driverVM.goodStudentType_ML.value && driverVM.goodStudentType_ML.value.code === 'none') {
            driverVM.goodStudentType_ML.value = undefined;
        }
        if (driverVM.goodStudentType_ML.value && !driverVM.isGoodStudent_ML.value) {
            driverVM.goodStudentType_ML.value = goodStudentTypeList.getCode('none');
        }
    }, [driverVM, goodStudentTypeList]);
    defaultGoodStudentType();

    const isSchoolAddressVisible = useCallback(() => {
        if (!submissionVM?.isModernProduct_Ext?.value) {
            return false;
        }
        // display school address fields if school name modifier is displaying
        const distantStudentMod =  driverVM.driverModifiers_ML?.modifiers?.value.find((mod) => mod.codeIdentifier_ML === 'PADistantStudent_Ext');
        return distantStudentMod?.chosenTermValue === 'true';
    }, [driverVM.driverModifiers_ML?.modifiers?.value, submissionVM?.isModernProduct_Ext?.value]);


    useEffect(() => {
        if (submissionVM?.isModernProduct_Ext?.value) {
            const distantStudentMod = driverVM.driverModifiers_ML?.modifiers?.value.find((mod) => mod.codeIdentifier_ML === 'PADistantStudent_Ext');
            if (!_.isUndefined(distantStudentMod)) {
                if (_.isUndefined(driverVM.schoolAddress_Ext?.value)) {
                    const addressObj = {
                        displayName: undefined,
                        state: undefined,
                        city: undefined,
                        postalCode: undefined,
                        country: 'US',
                        addressLine1: undefined,
                        addressLine2: undefined,
                        addressLine3: undefined
                    };

                    driverVM.schoolAddress_Ext = viewModelService.create(addressObj, 'pc', 'edge.capabilities.address.dto.AddressDTO');
                }
            } else {
                driverVM.schoolAddress_Ext = undefined;
            }
        }
    }, [driverVM.driverModifiers_ML?.modifiers?.value]);

    //
    // ViewForm
    //

    const handleValueChange = (value, path) => {
        if (path === 'requireProof') {
            driverVM.requiresProof_ML.value = value.code === 'true';
            if (value.code === 'false') {
                driverVM.caseNumber_ML.value = null;
                driverVM.cfreffDate_ML.value = null;
                driverVM.requestingState_ML.value = null;
            }
        } else if (path === 'isGoodStudent') {
            driverVM.isGoodStudent_ML.value = value.code === 'true';
            if (value.code === 'false') {
                driverVM.goodStudentType_ML.value = undefined;
            }
        } else if (path === 'goodStudentType') {
            driverVM.goodStudentType_ML.value = goodStudentTypeList.getCode(value.code);
        } else if (path === 'dateOfBirth') {
            if (!driverVM.dateOfBirth.aspects.valid) {
                return;
            }
            if (_.isUndefined(driverVM.fromPrefill_ML.value) || driverVM.fromPrefill_ML.value === true) {
                driverVM.fromPrefill_ML.value = false
                driverVM.driverAge_Ext.value = driverVM.dateOfBirth.value ? getDriverAge(driverVM.dateOfBirth.value) : 0;
            }
            driverVM.person.dateOfBirth.value = driverVM.dateOfBirth.value;
        } else if (path === 'ignitionInterlockCert_Ext') {
            if (!_.isUndefined(value)) {
                if (value.code === 'true') {
                    driverVM.ignitionInterlockCert_Ext.value = true;
                } else {
                    driverVM.ignitionInterlockCert_Ext.value = false;
                    driverVM.interlockExpirationDate_Ext = null;
                }
            }
        } else if (path === 'interlockExpirationDate_Ext') {
            if (_.isUndefined(value)) {
                driverVM.interlockExpirationDate_Ext = null;
            } else {
                driverVM.interlockExpirationDate_Ext = value;
            }
        } else if (path === 'governmentEmployee_Ext') {
            if (!_.isUndefined(value)) {
                if (value.code === 'true') {
                    driverVM.governmentEmployee_Ext.value = true;
                } else {
                    driverVM.governmentEmployee_Ext.value = false;
                }
            }
            driverVM.person.dateOfBirth.value = driverVM.dateOfBirth.value;
        }

        if (isQnB && path === "maritalStatus_ML") {
          const selectedStatus = value?.code ?? value;

          if (selectedStatus && selectedStatus !== "M" && driverVM?.spouseID_ML) {
            _.set(driverVM, "spouseID_ML.value", null);
          }
        }

        driverVM.editMode_ML.value = true;

        if (path === 'maritalStatus_ML' || path === 'dateOfBirth' || path === 'occupation_Ext') {
            if (updateModifiers) {
                updateModifiers();
            }
        }

        if (path === 'occupation_Ext') {
            driverVM.occupation_Ext.value = value
        }

        updateWizardData(submissionVM)
    };

    const isQnBEdit = isQnB && driverVM.editMode_ML.value

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate
        },
        resolveComponentMap: {
            spousepopovercomponent: SpousePopoverComponent,
            modifiercomponent: MLModifierComponent,
            mlnamedetailscomponent: MLNameDetailsComponent
        },
    };

    const checkIsStateWarningVisible = (driversList) => {
        if (driversList.filter((driver) => driver.licenseState === 'ust_ml' || driver.licenseState === "ca_ml").length > 0) {
            return true;
        }
        return false;
    };

    const checkIsgovernmentEmployeeTypeContainerVisible = () => {
        if (_.get(submissionVM, 'baseData.policyAddress.state.value') && _.get(submissionVM, 'baseData.policyAddress.state.value').code === 'VA' && driverVM.governmentEmployee_Ext.value) {
            return true;
        }
        return false;
    };

    const checkInterlockExpirationDateContainerVisible = () => {
        if (_.get(submissionVM, 'baseData.policyAddress.state.value') && _.get(submissionVM, 'baseData.policyAddress.state.value').code === 'MN' && driverVM.ignitionInterlockCert_Ext.value) {
            return true;
        }
        return false;
    };

    const checkIsDriverPNI = () => {
        if (_.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value') === _.get(driverVM, 'person.publicID.value')) {
            return true;
        }
        return false;
    };

    const writeValue = useCallback((value, path) => {
        _.set(driverVM, path, value);
        updateWizardData(submissionVM);
    }, [driverVM, submissionVM, updateWizardData]);


    const dobYear = driverVM?.dateOfBirth?.year?.value || ''
    
    const overrides = {
        stateLicenseWarning: {
            visible: checkIsStateWarningVisible(driverList) && !isPolicyChange
        },
        MLPAEditDriverContainer: {
            className: isPolicyChange ? 'ml-pa-edit-driver lowercase-input flex-column' : 'ml-pa-edit-driver flex-column'
        },
        SpousePopoverComponent: {
            submissionVM: submissionVM,
            driverVM: driverVM,
            driverList: driverList,
            visible: isMarriedStatus(),
            handleSpouseModelChange: handleDriverModelChange,
            updateModifiers: updateModifiers,
            onValidate: onValidate,
            isPolicyChange
        },
        modifierComponent: {
            driverModifiers: driverVM.driverModifiers_ML,
            updateModifier: updateModifiers,
            isFieldDefaultedByHvq: isModifierBridgedAndDefaultedByHVQ,
            showValidationErrors: showValidtionErrors,
            onValidate: onValidate,
            submissionVM: submissionVM,
            driverPage: isPolicyChange ? false : true,
            isPolicyChange
        },
        nameDetailsComponent: {
            personVM: driverVM.person,
            showValidationErrors: showValidtionErrors,
            onValidate: onValidate,
            onModelChange: () => {
                handleDriverModelChange();
                updateWizardData(submissionVM);
            },
            disableNameFields: driverVM.value.isPolicyHolder
        },
        requireProof: {
            value: {
                code: driverVM.requiresProof_ML && driverVM.requiresProof_ML.value ? 'true' : 'false'
            },
            className: isQnB ? "radioButtonQnB": ""
        },
        isGoodStudent: {
            value: {
                code: driverVM.isGoodStudent_ML && driverVM.isGoodStudent_ML.value ? 'true' : 'false'
            },
            className: isQnB ? "radioButtonQnB": ""
        },
        goodStudentType: {
            visible:!isModernProduct,
            value: {
                code: goodStudentType()
            },
            showValidationErrors: showValidtionErrors,
            validationMessages: driverVM.goodStudentType_ML.aspects.validationMessages,
            onValidate: onValidate,
            className: isQnB ? "radioButtonQnB": ""
        },
        driverLicenseContainer: {
            className: isQnB ? "row help-text-column vertical-spacing-20" : "row help-text-row vertical-spacing-20"
        },
        checkUniqueSelf: {
            visible: _.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", undefined) && !checkUniqueSelf(_.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", undefined))
        },
        checkUniqueSpouse: {
            visible: _.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", undefined) && !checkUniqueSpouse(_.get(submissionVM, "lobData.personalAuto.coverables.drivers.value", undefined))
        },
        martialStatusContainer: {
            className: isMarriedStatus()
                ? `row ${isQnB ? 'help-text-column' : 'help-text-row'}`
                : `row ${isQnB ? 'help-text-column' : 'help-text-row'} vertical-spacing-40`
        },
        goodStudentContainer: {
            visible: isGoodStudentVisible()
        },
        goodStudentOptionContainer: {
            visible: isGoodStudentOptionVisible()
        },
        relationshipWarning: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.relationshipToInsured_ML)
        },
        maritialStatusWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.maritalStatus_ML)
        },
        ageFirstLicensedWarning: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.ageFirstLicensed_ML)
        },
        stateLicensedWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.licenseState)
        },
        occupationWarningContainer: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.occupation_Ext)
        },
        goodStudentWarning: {
            visible: isModelBridgedAndDefaultedByHVQ(driverVM.isGoodStudent_ML)
        },
        ignitionInterlockContainer: {
            visible: _.get(submissionVM, 'baseData.policyAddress.state.value') && _.get(submissionVM, 'baseData.policyAddress.state.value').code === 'MN'
        },
        ignitionInterlock: {
            value: {
                code: driverVM.ignitionInterlockCert_Ext && driverVM.ignitionInterlockCert_Ext.value
            },
            className: isQnB ? "radioButtonQnB": ""
        },
        interlockExpirationDateContainer: {
            visible: checkInterlockExpirationDateContainerVisible()
        },
        interlockExpirationDate: {
            value: driverVM.interlockExpirationDate_Ext && driverVM.interlockExpirationDate_Ext.value ? driverVM.interlockExpirationDate_Ext.value : null
        },
        governmentEmployeeContainer: {
            visible: _.get(submissionVM, 'baseData.policyAddress.state.value') && _.get(submissionVM, 'baseData.policyAddress.state.value').code === 'VA'
        },
        governmentEmployee: {
            value: {
                code: driverVM.governmentEmployee_Ext && driverVM.governmentEmployee_Ext.value
            },
            className: isQnB ? "radioButtonQnB": ""
        },
        governmentEmployeeTypeContainer: {
            visible: checkIsgovernmentEmployeeTypeContainerVisible()
        },
        gender: {
            availableValues: getFilteredGender(nbGenderState),
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI(),
            className: isQnB ? "radioButtonQnB": ""
        },
        educationContainer: {
            visible: _.get(submissionVM, "isModernProduct_Ext.value", false) &&
                (driverVM.relationshipToInsured_ML?.value?.code === 'self' || driverVM.relationshipToInsured_ML?.value?.code === 'spouse')
        },
        occupation: {
            availableValues: occupationtypelist
        },
        occupationDefinitions: {
            visible: isModernProduct,
            tooltipContent: messages.occupationDefinitionContent,
            tooltipHeader: messages.occupationDefinitionTitle,
            tooltipContentClassName: styles.occupationContentStyles,
            tooltipHeaderClassName: styles.occupationHeaderStyle
        },
        schoolAddressContainer: {
            visible: isSchoolAddressVisible()
        },
        schoolAddressLookup: {
            id: 'schoolAddressLookup',
            onValueChange: writeValue,
            initialLockStateCity: false,
            value: schoolAddressVM,
			showValidationErrors: showValidtionErrors,
            isModernProduct
        },
        dobControl: {
            className: `${isQnB ? 'col-md-6 qnbDOBField col-md-6-qb' : 'col-md-6'}`
        },
        maritialStatusControl: {
            className: `${isQnB ? 'col-md-6 col-md-6-qb' : 'col-md-6'}`
        },
        firstName: {
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        lastName: {
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        dob: {
            showValidationErrors: showValidtionErrors,
            validationMessages: isQnB && !driverVM?.dateOfBirth?.value && driverVM?.fromPrefill_ML?.value ? [translator(messages.fieldRequired)] : driverVM.dateOfBirth.aspects.validationMessages,
            
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        relationship: {
            disabled: (submissionVM?.baseData?.primaryNamedInsured_ML?.maritalStatus?.value?.code === 'M' && driverVM?.relationshipToInsured_ML?.value?.code === 'spouse') || (!isQnB && driverVM.value.isPolicyHolder) || (isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()) || (isQnB && checkIsDriverPNI())
        },
        maritalStatus: {
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        middleName: {
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        suffix: {
            disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI()
        },
        middleNameColumn: {
            visible: !isQnB
        },
        suffixColumn: {
            visible: !isQnB
        },
        dobContainer: {
            className: isQnB ? "row help-text-column vertical-spacing-20" : "row help-text-row vertical-spacing-20"
        },
        stateContainer: {
            className: isQnB ? "row help-text-column vertical-spacing-20" : "row help-text-row vertical-spacing-20"
        },
        occupationContainer: {
            className: isQnB ? "row help-text-column vertical-spacing-20" : "row help-text-row vertical-spacing-20"
        },
        requireProofContainer: {
            className: isQnB ? "row help-text-column vertical-spacing-20" : "row help-text-row-requireProof vertical-spacing-20"
        },
        stateControl: {
            className: isQnB ? "col-md-6 col-md-6-qb" : "col-md-6"
        },
        ageControl: {
            className: isQnB ? "col-md-6 col-md-6-qb" : "col-md-6"
        },
        relationshipControl: {
            className: isQnB ? "col-md-4 remove-form-group-spacing col-md-6-qb" : "col-md-6"
        },
        occupationControl: {
            className: isQnB ? "col-md-6 col-md-6-qb" : "col-md-6"
        },
         occupationTooltipComponent:{
            visible: isQnB && !isModernProduct
        }
    };

    return (
        <ViewModelForm
            uiProps={isAgentEndorsement ? agentmetadata.componentContent : metadata.componentContent}
            model={driverVM}
            showErrors={showValidtionErrors}
            classNameMap={styles}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValidationChange={onValidate}
            onModelChange={handleDriverModelChange}
            onValueChange={handleValueChange}
        />
    );
}

MLPAEditDriverComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    driverVM: PropTypes.shape({}).isRequired,
    showValidtionErrors: PropTypes.bool.isRequired,
    handleDriverModelChange: PropTypes.func.isRequired,
    isFieldDefaultedByHvq: PropTypes.func,
    updateModifiers: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    isPolicyChange: PropTypes.bool,
    updateWizardData: PropTypes.func
};

MLPAEditDriverComponent.defaultProps = {
    isFieldDefaultedByHvq: undefined,
    isPolicyChange: false,
    updateWizardData: (value) => { }
};

export default MLPAEditDriverComponent;
